import { useEffect } from 'react';

export function useHtmlBackground(color: string) {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtml = html.style.backgroundColor;
    const prevBodyColor = body.style.backgroundColor;
    const prevBodyImage = body.style.backgroundImage;
    html.style.backgroundColor = color;
    body.style.backgroundColor = color;
    body.style.backgroundImage = 'none';
    return () => {
      html.style.backgroundColor = prevHtml;
      body.style.backgroundColor = prevBodyColor;
      body.style.backgroundImage = prevBodyImage;
    };
  }, [color]);
}
